/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { Fragment, useEffect, useReducer, useRef } from 'react';

import { EMPTY_STRING } from '../../const';
import optionsReducer from '../../reducers/multiOptions';
import filterMenuStyle from '../FiltersMenu/styles';
import useStyles from './styles';

const waysToPlayOptions = [
  {
    id: 1,
    text: 'Football',
    value: '1',
  },
  {
    id: 2,
    text: 'Futsal',
    value: '2',
  },
  {
    id: 3,
    text: 'Walking Football',
    value: '3',
  },
];

const FilterByWaysToPlay = ({
  onSave,
  currentValue,
  onErrorChange,
  filterShowHide,
}) => {
  const styles = useStyles();
  const filterMenuStyles = filterMenuStyle();

  const currentValueArray =
    currentValue && currentValue !== EMPTY_STRING
      ? currentValue.split(',')
      : [];

  const [optionsState, dispatch] = useReducer(
    optionsReducer,
    currentValueArray || []
  );

  const lastSavedValue = useRef(currentValueArray || []);

  // Handle input change
  const handleWaysToPlayOptionsChange = event => {
    const selectedValue = event.target.value;
    const inOptions = !!optionsState.find(value => value === selectedValue);
    if (inOptions) {
      dispatch({ type: 'remove', payload: { value: selectedValue } });
    } else {
      dispatch({ type: 'add', payload: { value: selectedValue } });
    }
  };

  // Call onSave only after currentValue updates
  useEffect(() => {
    if (optionsState !== lastSavedValue.current) {
      const filtersValue =
        optionsState.length === 0
          ? waysToPlayOptions.map(way => way.value).join(',') // all ways to play
          : optionsState.sort().join(',');

      onSave({
        WaysToPlay: filtersValue,
        RawWaysToPlay: optionsState, // raw user selection
      });
      lastSavedValue.current = optionsState;
    }
  }, [optionsState, onSave]);
  // for clear filter Sync local state with prop changes
  useEffect(() => {
    const newValueArray =
      currentValue && currentValue !== EMPTY_STRING
        ? currentValue.split(',')
        : [];

    dispatch({ type: 'reset', payload: { value: newValueArray } });
  }, [currentValue]);

  return (
    <Fragment>
      <div css={filterMenuStyles.filterHead}>
        <h5 css={filterMenuStyles.filterTitle}>Ways to play</h5>
      </div>
      <div css={filterMenuStyles.filterBody}>
        <ul css={styles.listWrapper}>
          {waysToPlayOptions &&
            waysToPlayOptions.map(({ id, text, value: optionValue }) => {
              const isChecked = optionsState.includes(optionValue);
              return (
                <li key={optionValue}>
                  <label
                    htmlFor={`way-${id}`}
                    css={styles.chooseFilter(isChecked)}
                    key={optionValue}
                  >
                    <span>{text}</span>
                    <input
                      type="checkbox"
                      id={`way-${id}`}
                      name={`way-${id}`}
                      checked={isChecked}
                      value={optionValue}
                      css={styles.optionCheckbox}
                      onChange={handleWaysToPlayOptionsChange}
                      tabIndex={filterShowHide ? 0 : -1}
                    />
                    <span />
                  </label>
                </li>
              );
            })}
        </ul>
      </div>
    </Fragment>
  );
};

FilterByWaysToPlay.propTypes = {
  currentValue: PropTypes.string,
  onSave: PropTypes.func,
};

export default FilterByWaysToPlay;
